export default {
  backHome: 'Back home',
  back: 'Go back',

  notFound: {
    title: 'Page not found',
    body: "The page you're looking for doesn't exist or has moved.",
  },

  forbidden: {
    title: "You don't have permission",
    body: "You're signed in, but this page is off-limits. If you think this is a mistake, contact support.",
  },

  server: {
    headlines: {
      maintenance: "We'll be right back",
      '500': 'Something went wrong',
      other: "We're having trouble connecting",
    },
    details: {
      maintenance: 'KeyzoStore is briefly offline for maintenance. Please check back in a few minutes.',
      '500': "An unexpected error occurred. We've been notified — please try again.",
      other: 'Our service is temporarily unavailable. Try again in a moment.',
    },
    retry: 'Retry',
  },
};
